import styled from 'styled-components'

export const TtsItemTextAreaWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
